module.exports = __webpack_public_path__ + "files/0948da95365dde053f9c61fa7aaddab4.png";